// Login.tsx - Login page container
//
// This component manages the login flow for the Sangati app. It toggles between the mobile number input and OTP verification screens.
//
// Features:
// - Renders the MobileInput component for phone number entry.
// - Renders the OTPInput component for OTP verification after phone submission.
// - Maintains state for the phone number and OTP screen toggle.
//
// Accessibility:
// - Uses a <main> tag with role="main" for accessibility.
//
// Usage:
// This component is used as the main login entry point. It should be rendered on the login route.

import React, { useState } from "react";

import MobileInput from "../components/Login/MobileInput";
import OTPInput from "../components/Login/OTPInput";

const Login: React.FC = () => {
  // State for phone input and OTP screen toggle
  const [phoneInput, setPhoneInput] = useState<string>("");
  const [showOtpScreen, setShowOtpScreen] = useState<boolean>(false);
  return (
    <main
      className="w-full max-w-md mx-auto min-h-screen py-6 md:py-10 px-4 md:px-7 lg:px-10 bg-bg-grey overflow-visible"
      role="main"
      aria-label="Login page"
    >
      {/*
        Renders MobileInput for phone entry, then OTPInput for OTP verification.
        Props are passed to manage state between the two steps.
      */}
      {!showOtpScreen ? (
        <MobileInput
          phoneInput={phoneInput}
          setPhoneInput={setPhoneInput}
          setShowOtpScreen={setShowOtpScreen}
        />
      ) : (
        <OTPInput setShowOtpScreen={setShowOtpScreen} phoneInput={phoneInput} />
      )}
    </main>
  );
};

export default Login;
